import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
export class GetTweetsByUserUseCaseImpl {
    constructor(tweetRepository, userRepository) {
        this.tweetRepository = tweetRepository;
        this.userRepository = userRepository;
    }
    run(username) {
        const user$ = from(this.userRepository.findUserByUsername(username));
        return user$.pipe(switchMap(user => this.getTweetsByUser(user)));
    }
    getTweetsByUser(user) {
        if (!user)
            return [];
        return this.tweetRepository.getTweetsByUserIds([user.id]);
    }
}
